import "./App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { AuthProvider } from "../firebase/AuthContext";
import Chat from "./Chat";
import Navbar from "./Navbar";
import Welcome from "./Welcome";
import Worlds from "./Worlds";
import Books from "./Books";
import Settings from "./Settings";
import Payment from "../stripe/Payment";
import PrivacyPolicy from "./PrivacyPolicy";
import Imprint from "./Imprint";
import ProtectedRoute from "./ProtectedRoute";
import PaymentComplete from "../stripe/PaymentComplete";
import BookTokens from "./BookTokens";
import ResetPassword from "./ResetPassword";
import Contact from "./Contact";
import SharedBook from "./SharedBook";
import TermsAndConditions from "./TermsAndConditions";
import TestChat from "./TestChat";
import CookieConsent from "react-cookie-consent";
import { useIsMobile } from "../hooks/useIsMobile";

function App() {
  const isMobile = useIsMobile();

  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <CookieConsent
            location="bottom"
            buttonText="Allow all cookies"
            declineButtonText="Decline optional cookies"
            enableDeclineButton
            onAccept={() => console.log("Cookies accepted")}
            onDecline={() => console.log("Cookies declined")}
            style={{
              backgroundColor: "rgba(0,0,0,0.7)",
              zIndex: 150,
              position: "absolute",
              textShadow: "0px 0px 5px purple",
              width: isMobile ? "100%" : "20%",
            }}
            buttonStyle={{
              border: "1px solid green",
              backgroundColor: "black",
              color: "#fff",
              textShadow: "0px 0px 5px purple",
              borderRadius: "5px",
            }}
            declineButtonStyle={{
              border: "1px solid red",
              backgroundColor: "black",
              color: "#fff",
              textShadow: "0px 0px 5px purple",
              borderRadius: "5px",
            }}
          >
            This website uses cookies.{" "}
            <Link to="/privacyPolicy" style={{ color: "white" }}>
              Learn more
            </Link>
          </CookieConsent>
          <Navbar></Navbar>
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/worlds" element={<Worlds />} />
            <Route
              path="/scenario"
              element={
                <ProtectedRoute>
                  <Chat />
                </ProtectedRoute>
              }
            />
            <Route path="/books" element={<Books />} />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment"
              element={
                <ProtectedRoute>
                  <Payment />
                </ProtectedRoute>
              }
            />
            <Route path="/freeTrial" element={<TestChat />} />
            <Route path="/bookTokens" element={<BookTokens />} />
            <Route path="/paymentStatus" element={<PaymentComplete />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/termsConditions" element={<TermsAndConditions />} />
            <Route path="/imprint" element={<Imprint />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/resetPassword" element={<ResetPassword />} />
            <Route path="/sharedBook" element={<SharedBook />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
